import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useLocation} from "react-router-dom";
import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";
import Select from "../../../ui/Select";
import PageLayout from "../../PageLayout";
import BillingItem from "../ParentMember/BillingItem";
import "./parent.css";
import "../../../common/billing.css";

const Billing = () => {
    const location = useLocation();
    const parent = clubStore.parent;

    useEffect(() => {
        if (!parent.company_id || parent.children.length > 0) return;
        parent.getChildren();
    }, [parent.company_id, location.pathname]);

    useEffect(() => {
        parent.setProperty("billing", []);
        if (parent.company_id && parent.child_id) parent.getBilling();
    }, [parent.company_id, parent.child_id, location.pathname]);

    const selectedChild = parent.children.find(child => child.id === parent.child_id);

    return (
        <PageLayout
            header={
                <div className="flex justify-content-between align-items-center w-full">
                    <div>
                        <h3 className="m-0">{appStore.tr.billing}</h3>
                        {selectedChild && (
                            <div className="text-600 mt-1">
                                <i className="pi pi-user mr-2"/>
                                {selectedChild.title}
                            </div>
                        )}
                    </div>
                </div>
            }
            filters={
                <div className="grid">
                    <div className="col-12 md:col-6">
                        <Select
                            store={parent}
                            prop="child_id"
                            options={parent.children}
                            optionLabel="title"
                            optionValue="id"
                            id="input_child"
                            label={appStore.tr.child}
                            disabled={parent.children.length === 0}
                        />
                    </div>
                </div>
            }
        >
            {parent.children.length === 0 ? (
                <div className="flex flex-column align-items-center justify-content-center py-5 text-600">
                    <i className="pi pi-users mb-2" style={{fontSize: "2rem"}}/>
                    <span>{appStore.tr.not_found}</span>
                </div>
            ) : parent.billing.length === 0 ? (
                <div className="flex flex-column align-items-center justify-content-center py-5 text-600">
                    <i className="pi pi-wallet mb-2" style={{fontSize: "2rem"}}/>
                    <span>{appStore.tr.not_found}</span>
                </div>
            ) : (
                parent.billing.map((period) => (
                    <BillingItem
                        period={period}
                        key={`${period.year}-${period.month}`}
                        url_base="/parent/children"
                    />
                ))
            )}
        </PageLayout>
    );
};

export default observer(Billing);
